// extracted by mini-css-extract-plugin
export default {"wrapper":"FileInput_wrapper__eUMXB","btn":"FileInput_btn__UWu7y","input":"FileInput_input__thEWa","file":"FileInput_file__ggb+3","file_empty":"FileInput_file_empty__i8Qsv"};